import { QueryClient } from '@tanstack/react-query'

/**
 * Maps agent mutation tools to the React Query key prefixes they should
 * invalidate when they succeed. Keys are matched against the FIRST segment
 * of each query's queryKey array (matches the existing key conventions in
 * src/services — keys look like ['/keywords', argString]).
 *
 * When the agent mutates data the user is currently viewing, we want the
 * page to refresh automatically — no manual reload, no websocket.
 */
const MUTATION_TOOL_INVALIDATIONS: Record<string, string[]> = {
    create_keyword: ['/keywords', '/keyword'],
    update_keyword: ['/keywords', '/keyword'],
    add_note_to_keyword: ['/keywords', '/keyword'],

    create_document: ['/documents', '/document', '/folders'],
    update_document: ['/documents', '/document', '/folders'],
    write_document_content: ['/documents', '/document'],
    delete_document: ['/documents', '/document', '/folders'],

    add_pipeline_group: ['/pipeline-config', '/keywords'],
    update_pipeline_group: ['/pipeline-config', '/keywords'],
    add_pipeline_subgroup: ['/pipeline-config', '/keywords'],
    update_pipeline_subgroup: ['/pipeline-config', '/keywords'],
}

export const isAgentMutationTool = (name: string): boolean =>
    name in MUTATION_TOOL_INVALIDATIONS

export const invalidateForAgentMutation = (queryClient: QueryClient, toolName: string): void => {
    const prefixes = MUTATION_TOOL_INVALIDATIONS[toolName]
    if (!prefixes || prefixes.length === 0) return

    queryClient.invalidateQueries({
        predicate: query => {
            const first = query.queryKey?.[0]
            return typeof first === 'string' && prefixes.includes(first)
        },
    })
}

// Exported for testing.
export const __MUTATION_TOOL_INVALIDATIONS = MUTATION_TOOL_INVALIDATIONS
